




































import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../system/mixins";
import { ButtonInfo } from "../../../domain/workflow/items";

@Component({})
export default class MessagesDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      nextMessagePermitted: false,
      nextMessageTitle: "",
      nextMessage: "",
      backMessagePermitted: false,
      backMessageTitle: "",
      backMessage: "",
      information: "",
    };
  }

  nextMessagePermitted: boolean;
  nextMessageTitle: string;
  nextMessage: string;

  backMessagePermitted: boolean;
  backMessageTitle: string;
  backMessage: string;

  information: string;

  async show(nextMessagePermission: ButtonInfo, nextMessage: string, backMessagePermission: ButtonInfo, backMessage: string): Promise<MessagesDialog> {
    return this.showModal(async () => {

      this.nextMessagePermitted = nextMessagePermission ? nextMessagePermission.isPermitted : false;
      this.nextMessageTitle = nextMessagePermission ? nextMessagePermission.buttonName : "伝達事項";
      this.nextMessage = nextMessage;

      this.backMessagePermitted = backMessagePermission ? backMessagePermission.isPermitted : false;
      this.backMessageTitle = backMessagePermission ? backMessagePermission.buttonName : "差戻しコメント";
      this.backMessage = backMessage;

      this.information = "※後からコメントタブで確認することができます。";

      await this.waitHidden();
      return this;
    });
  }

  close(): void {
    this.isVisible = false;
  }
}
